<template>
  <div class="main-body">
    <div class="header">
      护理项目
    </div>
    <div class="out">

      <div class="search2">

          <el-button size="mini" type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
          <el-button size="mini" type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button>

        <div style="float:right">
          <el-input  placeholder="请输入项目名称" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
          <el-select v-model="nursingTypeCode" clearable  placeholder="选择护理类型" style="margin:0 10px;">
            <el-option
                v-for="item in nursingTypeValue"
                :key="item.nursingTypeCode"
                :label="item.name"
                :value="item.nursingTypeCode">
            </el-option>
          </el-select>
          <el-select v-model="status" placeholder="选择房间项目状态" style="margin-right:10px;">
            <el-option
                v-for="item in statusValue"
                :key="item[0]"
                :label="item[1]"
                :value="item[0]">
            </el-option>
          </el-select>
          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

        <el-table-column prop="name" label="名称" ></el-table-column>

        <el-table-column prop="sort" label="排序" ></el-table-column>

        <el-table-column prop="nursingTypeName" label="护理类型" ></el-table-column>

        <el-table-column
            prop="status"
            :formatter="statusTitle"
            label="状态">
        </el-table-column>



      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      loading:false,
      row:null,
      menuButtonList:null,
      disabledAdd:false,
      disabledEdit:true,
      showModalAdd:false,
      showModalEdit:false,
      status:-1,
      name:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      nursingTypeValue:[],
      nursingTypeCode:'',
      statusValue:[[-1,'全部状态'],[0,'正常'],[1,'禁用']],
      th:0,

    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.getList();

    this.getNursingTypeList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    getNursingTypeList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'NursingType/List',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        console.log(response.data);
        if (response.data.error == 0) {
          this.nursingTypeValue = response.data.data;
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    rowClick(row){
      this.row=row;
      //if(this.menuButtonList.indexOf("编辑")!=-1){
        this.disabledEdit =false;
      //}

    },
    handleEdit() {
      this.$refs.myEdit.init(this.row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingItem/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name:this.name,
          nursingTypeCode:this.nursingTypeCode,
          status:this.status,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        console.log(response);
        this.loading = false;
        this.disabledEdit = true;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },



  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}
</style>
